import React, { useState, useEffect } from 'react';
//import { API_BASE_URL } from '../constants';
import ProcessImage from '../images/Process.png';
import { API_BASE_URL } from '../constants';
import axios from 'axios';

interface FaqItem {
    id?: number;
    question: string;
    answer: string;
}

const Faq: React.FC = () => {
    const [openIndices, setOpenIndices] = useState<number[]>([]);
    const [faqData, setFaqData] = useState<FaqItem[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    // Fetch FAQ data from the API
    const fetchFaqData = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get<FaqItem[]>(`${API_BASE_URL}/general/faq`);
            // Add image only if not already present
            const updatedData = response.data.map(item =>
                item.question === "Wie läuft der Nostrifizierungsprozess genau ab?"
                    ? item.answer.includes('<img')
                        ? item
                        : {
                            ...item,
                            answer: item.answer +
                                `<div style="margin-top:16px;">
                                    <img src="${ProcessImage}" alt="Nostrifizierungsprozess" style="max-width:100%" />
                                </div>`
                        }
                    : item
            );
            setFaqData(updatedData);
        }
        catch (error) {
            console.error("Error fetching FAQ data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchFaqData();
    }, []);

    const handleToggle = (index: number) => {
        setOpenIndices(prev =>
            prev.includes(index)
                ? prev.filter(i => i !== index)
                : [...prev, index]
        );
    };

    return (
        <div
            style={{
                maxWidth: 1110,
                margin: "40px auto",
                padding: 32,
                background: "#f3f4f7",
                borderRadius: 12,
                boxShadow: "0 2px 12px rgba(0,0,0,0.07)"
            }}
        >
            <h1 style={{ textAlign: "left", marginBottom: 32, borderBottom: "2px solid #b0b5be", paddingBottom: "10px" }}>FAQ</h1>
            {isLoading ? (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 40 }}>
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" aria-hidden>
                        <g>
                            <circle cx="12" cy="12" r="10" stroke="#e6e9ef" strokeWidth="3" fill="none" />
                            <path d="M22 12a10 10 0 0 1-10 10" stroke="rgb(255, 158, 27)" strokeWidth="3" strokeLinecap="round">
                                <animateTransform attributeName="transform" attributeType="XML" type="rotate" from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite" />
                            </path>
                        </g>
                    </svg>
                    <div style={{ marginTop: 12, color: "#555" }}>Lade FAQs…</div>
                </div>
            ) : (
                <>
                    {faqData.map((item, idx) => {
                        const hasImage = item.answer.includes("<img");
                        const maxHeight = hasImage ? "1500px" : "1000px";
                        return (
                            <div
                                key={idx}
                                style={{
                                    borderBottom: idx < faqData.length - 1 ? "2px solid #b0b5be" : "none",
                                    padding: "0 0 18px 0",
                                    marginBottom: 18
                                }}
                            >
                                <button
                                    onClick={() => handleToggle(idx)}
                                    style={{
                                        width: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        textAlign: "left",
                                        background: "none",
                                        border: "none",
                                        padding: "18px 0 8px 0",
                                        fontSize: "1.15em",
                                        cursor: "pointer",
                                        fontWeight: openIndices.includes(idx) ? "bold" : "normal",
                                        color: "#2d2d2d"
                                    }}
                                    aria-expanded={openIndices.includes(idx)}
                                >
                                    <span>{item.question}</span>
                                    <span style={{ fontSize: "1.1em", marginLeft: 12, transition: "transform 0.3s ease", transform: openIndices.includes(idx) ? "rotate(180deg)" : "rotate(0deg)" }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2d2d2d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <polyline points="6 9 12 15 18 9"></polyline>
                                        </svg>
                                    </span>
                                </button>
                                <div
                                    style={{
                                        maxHeight: openIndices.includes(idx) ? maxHeight : "0",
                                        overflow: "hidden",
                                        transition: openIndices.includes(idx) ? "max-height 1s ease-out" : "max-height 0s",
                                        color: "#333"
                                    }}
                                >
                                    <div
                                        style={{
                                            paddingTop: "25px",
                                            paddingBottom: "8px"
                                        }}
                                        dangerouslySetInnerHTML={{ __html: item.answer }}
                                    />
                                </div>
                            </div>
                        );
                    })}
                </>
            )}
            <div style={{ display: "flex", justifyContent: "center", marginTop: 24 }}>
                <button
                    onClick={() => window.history.back()}
                    style={{
                        padding: "8px 24px",
                        borderRadius: 6,
                        border: "none",
                        background: "transparent",
                        color: "#222",
                        fontWeight: "bold",
                        cursor: "pointer"
                    }}
                >
                    Zurück
                </button>
            </div>
        </div>
    );
};

export default Faq;